import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ArrowBackIcon(props: IconProps) {
    return <Icon {...props} iconKey={"arrow_back"}/>
}
